import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import filterChildren from "../../../utils/Children/filterChildren";
var TableHeader = function TableHeader(props) {
  var className = props.className,
    id = props.id,
    style = props.style,
    secondaryDataList = props.secondaryDataList,
    children = props.children;
  var tableHeaderClass = function tableHeaderClass() {
    return classNames({
      'ui-table-header': true
    }, className);
  };
  var newChildren = filterChildren(children, {
    secondaryDataList: secondaryDataList
  });
  return /*#__PURE__*/React.createElement("thead", {
    id: id,
    className: tableHeaderClass(),
    style: style
  }, newChildren);
};
TableHeader.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Data (in columns) to hide passed from TableRow component
   * @ignore
   */
  secondaryDataList: PropTypes.array
};
TableHeader.defaultProps = {
  id: '',
  className: '',
  children: [],
  style: {},
  secondaryDataList: []
};
export default TableHeader;